import React from 'react';
import Layout from '../../components/Layout';
import RentwayPanel from '../OperationsPortal/components/RentwayPanel';

// Operations > Brokers (owner, 23 Oct 2026: "صفحة جديدة فى الاوبريشن اسمها rentway" - a page of its own in the
// Operations menu; renamed "Brokers" the same day when the Comfy site joined): the booking sites' Dubai reservations
// in Rentway and Comfy against their Ejar bookings. Its Availability tab became Operations > Availability (owner,
// 24 Oct 2026: every airport model, not only the booking sites' groups).
export default function RentwayPage() {
    return (
        <Layout title="Brokers" subtitle="Booking sites' Dubai reservations (Rentway + Comfy) checked against Ejar">
            <div className="w-full mx-auto">
                <RentwayPanel />
            </div>
        </Layout>
    );
}
